import { FC, ReactNode } from 'react'
import { Routes, Route, Outlet, Navigate } from 'react-router-dom'

import ScreenshotsModalContainer from '../../features/news/components/ScreenshotsModalContainer/ScreenshotsModalContainer'
import ReportCardPreview from '../../features/reports/components/ReportCardPreview/ReportCardPreview'
import { UpdateModalContainer } from '../../features/update-modal/components/UpdateModalContainer/UpdateModalContainer'
import { InternalHomeRedirect } from '../../internal/components/InternalHomeRedirect/InternalHomeRedirect'
import { InternalRolesRoute } from '../../internal/components/InternalRolesRoute/InternalRolesRoute'
import { InternalRoute } from '../../internal/components/InternalRoute/InternalRoute'
import { AdDataTesterPage } from '../../internal/pages/ad-data-tester/AdDataTesterPage'
import { AiPromptDetailPage } from '../../internal/pages/ai-prompts/AiPromptDetailPage'
import { AiPromptsPage } from '../../internal/pages/ai-prompts/AiPromptsPage'
import { AnalysisSuggestionsPage } from '../../internal/pages/analysis-suggestions/AnalysisSuggestionsPage'
import { AnalysisFeatureChoicesPage } from '../../internal/pages/analysis/AnalysisFeatureChoicesPage'
import { AnalysisOverviewPage } from '../../internal/pages/analysis/AnalysisOverviewPage'
import { AnalysisScreenshotsEditPage } from '../../internal/pages/analysis/AnalysisScreenshotsEditPage'
import { AnalysisScreenshotsPage } from '../../internal/pages/analysis/AnalysisScreenshotsPage'
import { AnalysisScreenshotsUploadPage } from '../../internal/pages/analysis/AnalysisScreenshotsUploadPage'
import { AnalystsPage } from '../../internal/pages/analysts/AnalystsPage'
import { BrandEditPage } from '../../internal/pages/brands/BrandEditPage'
import { BrandsPage } from '../../internal/pages/brands/BrandsPage'
import { CategoriesPage } from '../../internal/pages/categories/CategoriesPage'
import { FeatureBulkAssignPage } from '../../internal/pages/categories/FeatureBulkAssignPage'
import { FeatureEditPage } from '../../internal/pages/categories/FeatureEditPage'
import { ConventionalGenresPage } from '../../internal/pages/conventional-genres/ConventionalGenresPage'
import { DashboardPage } from '../../internal/pages/dashboard/DashboardPage'
import { EditorialCardEditPage } from '../../internal/pages/editorial-cards/EditorialCardEditPage'
import { EditorialCardsPage } from '../../internal/pages/editorial-cards/EditorialCardsPage'
import { FtueVideoAttachPage } from '../../internal/pages/ftue-videos/FtueVideoAttachPage'
import { FtueVideoEditPage } from '../../internal/pages/ftue-videos/FtueVideoEditPage'
import { FtueVideosPage as InternalFtueVideosPage } from '../../internal/pages/ftue-videos/FtueVideosPage'
import { AnalysisCommentEditPage } from '../../internal/pages/games/AnalysisCommentEditPage'
import { GameReviewEditPage } from '../../internal/pages/games/GameReviewEditPage'
import { GamesPage } from '../../internal/pages/games/GamesPage'
import { ImplementationBulkAssignEditPage } from '../../internal/pages/implementation-bulk-assign/ImplementationBulkAssignEditPage'
import { ImplementationBulkAssignPage } from '../../internal/pages/implementation-bulk-assign/ImplementationBulkAssignPage'
import { ImplementationExamplesPage as InternalImplementationExamplesPage } from '../../internal/pages/implementation-examples/ImplementationExamplesPage'
import { ImplementationScreenshotsPage } from '../../internal/pages/implementation-examples/ImplementationScreenshotsPage'
import { ScreenshotCommentEditPage } from '../../internal/pages/implementation-examples/ScreenshotCommentEditPage'
import { ImportToolPage } from '../../internal/pages/import-tool/ImportToolPage'
import { KeywordsPage } from '../../internal/pages/keywords/KeywordsPage'
import { AnalystNoteEditPage } from '../../internal/pages/live-events-tracking/AnalystNoteEditPage'
import { EventArchetypesEditPage } from '../../internal/pages/live-events-tracking/EventArchetypesEditPage'
import { MarketLevelBlueprintsEditPage } from '../../internal/pages/live-events-tracking/MarketLevelBlueprintsEditpage'
import { MarketLevelBlueprintsOverviewPage } from '../../internal/pages/live-events-tracking/MarketLevelBlueprintsOverviewPage'
import { SearchGamesPage } from '../../internal/pages/live-events-tracking/SearchGamesPage'
import { TrackedGameAnalystNotesPage } from '../../internal/pages/live-events-tracking/TrackedGameAnalystNotesPage'
import TrackedGameEventAnalysisPage from '../../internal/pages/live-events-tracking/TrackedGameEventAnalysisPage'
import { TrackedGameEventEditPage } from '../../internal/pages/live-events-tracking/TrackedGameEventEditPage'
import { TrackedGameEventsOverviewPage } from '../../internal/pages/live-events-tracking/TrackedGameEventsOverviewPage'
import { TrackedGameEventsPage } from '../../internal/pages/live-events-tracking/TrackedGameEventsPage'
import { TrackedGamesPage } from '../../internal/pages/live-events-tracking/TrackedGamesPage'
import { MarketsPage } from '../../internal/pages/markets/MarketsPage'
import { MetadataTagsPage } from '../../internal/pages/metadata-tags/MetadataTagsPage'
import { MotivationsPage } from '../../internal/pages/motivations/MotivationsPage'
import { OnboardingVideoAddPage } from '../../internal/pages/onboarding-videos/OnboardingVideoAddPage'
import { OnboardingVideoEditPage } from '../../internal/pages/onboarding-videos/OnboardingVideoEditPage'
import { OnboardingVideosPage } from '../../internal/pages/onboarding-videos/OnboardingVideosPage'
import { OrganizationAccessPage } from '../../internal/pages/organizations/OrganizationAccessPage'
import { OrganizationsPage } from '../../internal/pages/organizations/OrganizationsPage'
import { PlansPage } from '../../internal/pages/plans/PlansPage'
import { ReportEditPage as InternalReportEditPage } from '../../internal/pages/reports/ReportEditPage'
import { ReportsPage as InternalReportsPage } from '../../internal/pages/reports/ReportsPage'
import { SettingsPage } from '../../internal/pages/settings/SettingsPage'
import { StoresPage } from '../../internal/pages/stores/StoresPage'
import { TagGroupsPage } from '../../internal/pages/tag-groups/TagGroupsPage'
import { TagsAssignPage } from '../../internal/pages/tags/TagsAssignPage'
import { TagsPage } from '../../internal/pages/tags/TagsPage'
import { UsersPage } from '../../internal/pages/users/UsersPage'
import PageService from '../../services/PageService'
import AIAnalystPage from '../AIAnalyst/AIAnalystPage'
import CompareGamesPage from '../CompareGamesPage/CompareGamesPage'
import DailyInsightsPage from '../DailyInsightsPage/DailyInsightsPage'
import DataGlossaryPage from '../DataGlossaryPage/DataGlossaryPage'
import FollowedGamesPage from '../FollowedGamesPage/FollowedGamesPage'
import FtueVideosPage from '../FtueVideosPage/FtueVideosPage'
import GameAnalyzerDetailPage from '../GameAnalyzerDetailPage/GameAnalyzerDetailPage'
import GameAnalyzerPage from '../GameAnalyzerPage/GameAnalyzerPage'
import GamePage from '../GamePage/GamePage'
import GamePageWrapper from '../GamePage/GamePageWrapper'
import GenreEssentialsPage from '../GenreEssentialsPage/GenreEssentialsPage'
import ImplementationExamplesPage from '../ImplementationExamplesPage/ImplementationExamplesPage'
import InvitesPage from '../InvitesPage/InvitesPage'
import LiveEventsTrackerPage from '../LiveEventsTrackerPage/LiveEventsTrackerPage'
import MarketExplorerPage from '../MarketExplorerPage/MarketExplorerPage'
import MarketSharePage from '../MarketSharePage/MarketSharePage'
import MarketTrendsPage from '../MarketTrendsPage/MarketTrendsPage'
import MyProfilePage from '../MyProfilePage/MyProfilePage'
import OrganizationPage from '../OrganizationPage/OrganizationPage'
import OrganizationUsersPage from '../OrganizationUsersPage/OrganizationUsersPage'
import { RegisterPage } from '../RegisterPage/RegisterPage'
import ReportsPage from '../ReportsPage/ReportsPage'
import SingleUnifiedNewsEntryPage from '../SingleUnifiedNewsEntryPage/SingleUnifiedNewsEntryPage'
import SlackIntegrationPage from '../SlackIntegrationPage/SlackIntegrationPage'
import SlackPreferencesPage from '../SlackPreferencesPage/SlackPreferencesPage'
import { SoftLaunchPage } from '../SoftLaunchPage/SoftLaunchPage'
import TopGrossingPage from '../TopGrossingPage/TopGrossingPage'
import { UnsubscribeDailyDigestPage } from '../UnsubscribeDailyDigestPage/UnsubscribeDailyDigestPage'
import { UpdateImpactsPage } from '../UpdateImpactsPage/UpdateImpactsPage'
import VisualExplorerPage from '../VisualExplorerPage/VisualExplorerPage'
import { AuthenticatedRoute } from './AuthenticatedRoute/AuthenticatedRoute'
import { LiveEventsEventDialogContainerDeprecated, LiveEventsEventStatisticsDialogContainerDeprecated } from './DeprecatedModalRoutes/DeprecatedModalRoutes'
import { UnauthenticatedRoute } from './UnauthenticatedRoute/UnauthenticatedRoute'

type AppRoutesProps = {
  children?: ReactNode
}

export const AppRoutes: FC<AppRoutesProps> = ({ children }) => {
  return (
    <Routes>
      <Route path="/unsubscribe-daily-digest" element={<UnsubscribeDailyDigestPage />} />
      <Route element={<UnauthenticatedRoute />}>
        <Route path="/register" element={<RegisterPage />} />
      </Route>
      <Route element={<AuthenticatedRoute />}>
        <Route path="/internal" element={<InternalRoute />}>
          {[...PageService.internalPages, ...PageService.internalAdminPages].map((page) => {
            const Page = internalPageIdToComponentMap[page.id]
            if (!Page) return null
            const route = <Route key={page.id} path={page.href} element={<Page />} />
            return page.requiredRoles ? (
              <Route key={page.id} element={<InternalRolesRoute roles={page.requiredRoles} />}>
                {route}
              </Route>
            ) : (
              route
            )
          })}
          <Route
            path="/internal/live-events-tracking/market-level-blueprints/edit"
            element={<Navigate replace to="/internal/live-events-tracking/market-level-blueprints/edit/us" />}
          />
          <Route index element={<InternalHomeRedirect />} />
        </Route>

        {PageService.pages.map((page) => {
          const Page = pageIdToComponentMap[page.id]
          return (
            Page && (
              <Route
                key={page.id}
                path={page.href}
                element={
                  <ModalOutlet>
                    <Page />
                  </ModalOutlet>
                }
              >
                {/* TODO: game update modal and screenshot modal need to be refactored to use url search params instead of path params */}
                <Route path="gameupdate/:gameId/:gameVersion/:marketIso/*" element={<UpdateModalContainer />} />
                <Route path="screenshots/:screenshots/:shot?/*" element={<ScreenshotsModalContainer />} />

                {/* Routes for depracated path based modals for redirecting to new url search params based modals */}
                <Route
                  path="liveevent/:trackedGameId/:liveEventTypeId/liveEventId?/:liveEventId?/tab?/:tab?/screenshotIndex?/:screenshotIndex?/*"
                  element={<LiveEventsEventDialogContainerDeprecated />}
                />
                <Route path="liveeventstatistics/:gameIds/:liveEventTypeId/:tab/*" element={<LiveEventsEventStatisticsDialogContainerDeprecated />}></Route>
              </Route>
            )
          )
        })}
        <Route index element={<Navigate replace to="/daily-insights" />} />
        <Route path={'*'} element={<Navigate replace to="/daily-insights" />} />
      </Route>
    </Routes>
  )
}

const ModalOutlet: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <>
      <Outlet />
      {children}
    </>
  )
}

// mapping of pageId to page component
const pageIdToComponentMap: { [pageId: string]: FC | undefined } = {
  'data-glossary': DataGlossaryPage,
  'data-glossary-detail': DataGlossaryPage,
  'daily-insights': DailyInsightsPage,
  'daily-insights-wildcard': DailyInsightsPage,
  'genre-essentials': GenreEssentialsPage,
  'top-grossing': TopGrossingPage,
  'soft-launch': SoftLaunchPage,
  'market-explorer': MarketExplorerPage,
  'market-share': MarketSharePage,
  'visual-explorer': VisualExplorerPage,
  reports: ReportsPage,
  'report-detail': ReportCardPreview,
  'market-trends': MarketTrendsPage,
  'live-events-tracker': LiveEventsTrackerPage,
  'ai-analyst': AIAnalystPage,
  'followed-games': FollowedGamesPage,
  'compare-games': CompareGamesPage,
  'game-update-impacts': UpdateImpactsPage,
  'implementation-examples': ImplementationExamplesPage,
  'ftue-videos': FtueVideosPage,
  'game-analyzer': GameAnalyzerPage,
  'game-analyzer-detail': GameAnalyzerDetailPage,
  'news-card': SingleUnifiedNewsEntryPage,
  game: GamePage,
  'game-tab': GamePageWrapper,
  'my-profile': MyProfilePage,
  organization: OrganizationPage,
  'organization-users': OrganizationUsersPage,
  slack: SlackIntegrationPage,
  'slack-preferences': SlackPreferencesPage,
  invites: InvitesPage,
}

// mapping of internal pageId to page component
const internalPageIdToComponentMap: { [pageId: string]: FC | undefined } = {
  'internal-tracked-games': TrackedGamesPage,
  'internal-tracked-game-events': TrackedGameEventsPage,
  'internal-tracked-game-events-edit-event': TrackedGameEventEditPage,
  'internal-tracked-games-search': SearchGamesPage,
  'internal-tracked-game-analyst-notes': TrackedGameAnalystNotesPage,
  'internal-tracked-game-analyst-note-edit': AnalystNoteEditPage,
  'internal-tracked-game-events-overview': TrackedGameEventsOverviewPage,
  'internal-tracked-game-event-analysis': TrackedGameEventAnalysisPage,
  'internal-event-archetypes-edit': EventArchetypesEditPage,
  'internal-event-archetype-edit': EventArchetypesEditPage,
  'internal-market-level-blueprints-edit': MarketLevelBlueprintsEditPage,
  'internal-market-level-blueprints-overview': MarketLevelBlueprintsOverviewPage,
  'internal-ai-prompts': AiPromptsPage,
  'internal-ai-prompt-detail': AiPromptDetailPage,
  'internal-keywords': KeywordsPage,
  'internal-metadata-tags': MetadataTagsPage,
  'internal-stores': StoresPage,
  'internal-tag-groups': TagGroupsPage,
  'internal-tags': TagsPage,
  'internal-tags-assign': TagsAssignPage,
  'internal-import-tool': ImportToolPage,
  'internal-analysts': AnalystsPage,
  'internal-reports': InternalReportsPage,
  'internal-report-edit': InternalReportEditPage,
  'internal-ftue-videos': InternalFtueVideosPage,
  'internal-ftue-video-attach': FtueVideoAttachPage,
  'internal-ftue-video-edit': FtueVideoEditPage,
  'internal-analysis-suggestions': AnalysisSuggestionsPage,
  'internal-dashboard': DashboardPage,
  'internal-conventional-genres': ConventionalGenresPage,
  'internal-markets': MarketsPage,
  'internal-motivations': MotivationsPage,
  'internal-organizations': OrganizationsPage,
  'internal-organization-access': OrganizationAccessPage,
  'internal-plans': PlansPage,
  'internal-settings': SettingsPage,
  'internal-ad-data-tester': AdDataTesterPage,
  'internal-editorial-cards': EditorialCardsPage,
  'internal-editorial-card-edit': EditorialCardEditPage,
  'internal-onboarding-videos': OnboardingVideosPage,
  'internal-onboarding-video-add': OnboardingVideoAddPage,
  'internal-onboarding-video-edit': OnboardingVideoEditPage,
  'internal-brands': BrandsPage,
  'internal-brand-edit': BrandEditPage,
  'internal-games': GamesPage,
  'internal-game-review-edit': GameReviewEditPage,
  'internal-analysis-comment-edit': AnalysisCommentEditPage,
  'internal-analysis-overview': AnalysisOverviewPage,
  'internal-analysis-screenshots': AnalysisScreenshotsPage,
  'internal-analysis-screenshots-upload': AnalysisScreenshotsUploadPage,
  'internal-analysis-screenshots-edit': AnalysisScreenshotsEditPage,
  'internal-analysis-feature-choices': AnalysisFeatureChoicesPage,
  'internal-users': UsersPage,
  'internal-categories': CategoriesPage,
  'internal-category-feature-edit': FeatureEditPage,
  'internal-feature-bulk-assign': FeatureBulkAssignPage,
  'internal-implementation-examples': InternalImplementationExamplesPage,
  'internal-implementation-screenshots': ImplementationScreenshotsPage,
  'internal-screenshot-comment-edit': ScreenshotCommentEditPage,
  'internal-implementation-bulk-assign': ImplementationBulkAssignPage,
  'internal-implementation-bulk-assign-mode': ImplementationBulkAssignPage,
  'internal-implementation-bulk-assign-edit': ImplementationBulkAssignEditPage,
}
